import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";
import { useHistory } from "react-router-dom";

import TopMenu from "components/Home/Utils/TopMenu";
import * as MarketReducer from "containers/CommunityMarket/MarketReducer";
import { SORTING_OPTIONS } from "containers/CommunityMarket/MarketReducer";
import * as viewReducer from "containers/View/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import HeaderTab from "aible/HeaderTab/HeaderTab";

import marketLogo from "images/marketplaceLogo.png";
import FilterIcon from "images/filter-purple.svg";

import styles from "./style.module.css";
import { Button } from "aible";
import MarketGrid from "components/CommunityMarket/MarketGrid";
import CartGrid from "components/CommunityMarket/CartGrid";
import MarketFiltersPanel from "components/CommunityMarket/MarketFiltersPanel";
import SearchInput from "components/Inputs/SearchInput/SearchInput";
import Select from "react-select";

// import marketReducer from "containers/Market/MarketReducer";

const Market = (props) => {
  const {} = props;

  const dispatch = useDispatch();
  const history = useHistory();

  const tabViewOptions = ["all", "models", "chat apps", "use cases"];

  const updateType = (type) => dispatch(viewReducer.updateType(type));

  const tabView = useSelector((state) => MarketReducer.getTabView(state));
  const updateTabView = (view) => dispatch(MarketReducer.updateTabView(view));
  const isFiltersOpen = useSelector((state) => MarketReducer.getIsFiltersOpen(state));
  const updateIsFiltersOpen = (bool) => dispatch(MarketReducer.updateIsFiltersOpen(bool));
  const isLoadingItems = useSelector((state) => MarketReducer.getIsLoadingItems(state));
  const isCartOpen = useSelector((state) => MarketReducer.getIsCartOpen(state));
  const updateIsCartOpen = (bool) => dispatch(MarketReducer.updateIsCartOpen(bool));

  const cartItemsArray = useSelector((state) => MarketReducer.getCartItemsArray(state));

  const [searchFilter, updateSearchFilter] = useState(undefined);

  useEffect(() => {
    dispatch(MarketReducer.resetMarket());
  }, []);

  useEffect(() => {
    dispatch(MarketReducer.fetchAllMarketListings());
  }, []);

  const allListings = useSelector((state) => MarketReducer.getAllListings(state));

  const filterOptions = useSelector((state) => MarketReducer.getFilterOptions(state));

  const sortBy = useSelector((state) => MarketReducer.getSortBy(state));
  const updateSortBy = (sortObj) => dispatch(MarketReducer.updateSortBy(sortObj));

  const sortedData = useSelector((state) => MarketReducer.getSortedData(state));

  const sortOptions = SORTING_OPTIONS;

  const searchFilteredData = sortedData.filter((item) =>
    !searchFilter || searchFilter?.length < 1 ? item : item?.name?.toLowerCase()?.includes(searchFilter?.toLowerCase())
  );

  const cartData = cartItemsArray.map((itemId) => {
    return allListings.find((i) => i?.id === itemId);
  });

  return (
    <div className={styles.marketContainer}>
      <div className={styles.marketHeader}>
        {/* <TopMenu
          options={tabViewOptions}
          selectHandler={updateTabView}
          selected={tabView}
        /> */}
        <div className={styles.marketTabContainer}>
          {tabViewOptions.map((option, index) => {
            return (
              <HeaderTab
                title={option}
                onClick={() => updateTabView(option)}
                isActive={tabView === option}
                isDisabled={index > 1}
                key={option + "__ + index"}
              />
            );
          })}
        </div>
        <div className={styles.marketTopActions}>
          <Button
            onClick={() => {
              history.push("/");
              updateType("LLM Fine-Tuning");
            }}
            style={{ marginRight: "10px" }}
            className={styles.topActionButton}
          >
            {"Sell Models"}
          </Button>
          <Button
            onClick={() => {
              updateIsCartOpen(!isCartOpen);
            }}
            style={{ minWidth: "99px" }}
            className={styles.topActionButton}
          >
            {isCartOpen ? `Close Cart (${cartItemsArray?.length})` : `Cart (${cartItemsArray?.length})`}
          </Button>
        </div>
      </div>
      <div className={styles.marketPanelsContainer}>
        <div className={styles.marketBodyPanel}>
          <div className={styles.marketHeaderActions}>
            <Button
              onClick={() => {
                updateIsFiltersOpen(!isFiltersOpen);
              }}
              style={{ marginRight: "20px", minWidth: "110px" }}
            >
              <img className={styles.filterButtonIcon} src={FilterIcon} />
              {isFiltersOpen ? "Close Filters" : "Filters"}
            </Button>
            <SearchInput
              value={searchFilter}
              onChange={(val) => updateSearchFilter(val)}
              style={{ marginRight: "10px", height: "40px" }}
              placeholder={"Filter by name"}
            />
            <div className={styles.searchResultsText} style={{ marginRight: "20px" }}>
              {`${searchFilteredData?.length} Results`}
            </div>
            <div className={styles.sortingSelector}>
              <Select
                placeholder={"Select an option to sort by"}
                options={sortOptions}
                value={sortOptions.find((o) => o.value.val === sortBy.val && o.value.dir == sortBy.dir)}
                onChange={(val) => updateSortBy(val.value)}
              />
            </div>
          </div>
          <div className={styles.marketContentContainer}>
            {isFiltersOpen && (
              <div className={styles.marketFilterPanel}>
                <MarketFiltersPanel />
              </div>
            )}
            <div className={styles.marketBodyContainer}>
              <div className={styles.marketActiveFiltersContainer}>
                {/* <div className={styles.activeFilterWrapper}>
                  {"Filter Placeholder"}
                </div> */}
              </div>
              {isLoadingItems ? (
                <LoadingIndicator />
              ) : (
                <MarketGrid cards={searchFilteredData} initialColumnsCount={6} />
              )}
            </div>
          </div>
        </div>
        {isCartOpen ? (
          <div className={styles.marketCartPanel}>
            {cartItemsArray?.length > 0 ? (
              <CartGrid cards={cartData} />
            ) : (
              <div className={styles.emptyCartText}>
                {"Your cart is empty. You will see your items here after you add any to your cart."}
              </div>
            )}
          </div>
        ) : (
          <div
          // style={{ width: "15%", padding: "20px" }}
          />
        )}
      </div>
    </div>
  );
};

export default Market;
